import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const RecommendationHeader = ({ 
  totalRecommendations = 0,
  bikeModel = "",
  analysisDate = "",
  onViewAnalysis,
  onToggleFilters,
  onToggleCart,
  cartItemCount = 0,
  sortBy = 'relevance',
  onSortChange
}) => {
  const sortOptions = [
    { value: 'relevance', label: 'Most Relevant' },
    { value: 'price-low', label: 'Price: Low to High' },
    { value: 'price-high', label: 'Price: High to Low' },
    { value: 'rating', label: 'Highest Rated' },
    { value: 'performance', label: 'Best Performance' },
    { value: 'newest', label: 'Newest First' }
  ];

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      {/* Main Header */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between mb-4">
        <div className="mb-4 lg:mb-0">
          <h1 className="text-2xl lg:text-3xl font-bold text-foreground mb-2">
            Upgrade Recommendations
          </h1>
          <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-4 text-sm text-muted-foreground">
            {bikeModel && (
              <div className="flex items-center space-x-2">
                <Icon name="Bike" size={16} />
                <span>{bikeModel}</span>
              </div>
            )}
            {analysisDate && (
              <div className="flex items-center space-x-2">
                <Icon name="Calendar" size={16} />
                <span>Analyzed on {formatDate(analysisDate)}</span>
              </div>
            )}
            <div className="flex items-center space-x-2">
              <Icon name="Target" size={16} />
              <span>{totalRecommendations} recommendations found</span>
            </div>
          </div>
        </div>

        {/* Action Buttons - Desktop */}
        <div className="hidden lg:flex items-center space-x-3">
          <Button
            variant="outline"
            size="sm"
            iconName="BarChart3"
            iconPosition="left"
            onClick={onViewAnalysis}
          >
            View Analysis
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="Filter"
            iconPosition="left"
            onClick={onToggleFilters}
          >
            Filters
          </Button>
          <button
            onClick={onToggleCart}
            className="relative p-2 bg-accent text-accent-foreground rounded-md hover:bg-accent/90 transition-colors interactive-scale"
          >
            <Icon name="ShoppingCart" size={20} />
            {cartItemCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-error text-error-foreground text-xs w-5 h-5 rounded-full flex items-center justify-center">
                {cartItemCount}
              </span>
            )}
          </button>
        </div>
      </div>

      {/* Controls Bar */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Sort and View Options */}
        <div className="flex items-center space-x-4">
          <div className="w-48">
            <Select
              options={sortOptions}
              value={sortBy}
              onChange={onSortChange}
              placeholder="Sort by..."
            />
          </div>
          
          <div className="hidden sm:flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="Info" size={16} />
            <span>Prices updated hourly</span>
          </div>
        </div>

        {/* Mobile Action Buttons */}
        <div className="flex lg:hidden items-center justify-between">
          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              iconName="BarChart3"
              iconPosition="left"
              onClick={onViewAnalysis}
            >
              Analysis
            </Button>
            <Button
              variant="outline"
              size="sm"
              iconName="Filter"
              iconPosition="left"
              onClick={onToggleFilters}
            >
              Filter
            </Button>
          </div>
          
          <button
            onClick={onToggleCart}
            className="relative p-2 bg-accent text-accent-foreground rounded-md hover:bg-accent/90 transition-colors interactive-scale"
          >
            <Icon name="ShoppingCart" size={20} />
            {cartItemCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-error text-error-foreground text-xs w-5 h-5 rounded-full flex items-center justify-center">
                {cartItemCount}
              </span>
            )}
          </button>
        </div>
      </div>

      {/* Quick Stats */}
      <div className="mt-4 pt-4 border-t border-border">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <div className="text-center">
            <div className="text-lg font-semibold text-foreground">
              {totalRecommendations}
            </div>
            <div className="text-xs text-muted-foreground">
              Total Upgrades
            </div>
          </div>
          <div className="text-center">
            <div className="text-lg font-semibold text-success">
              $2,450
            </div>
            <div className="text-xs text-muted-foreground">
              Potential Savings
            </div>
          </div>
          <div className="text-center">
            <div className="text-lg font-semibold text-accent">
              4.8/5
            </div>
            <div className="text-xs text-muted-foreground">
              Avg. Rating
            </div>
          </div>
          <div className="text-center">
            <div className="text-lg font-semibold text-warning">
              85%
            </div>
            <div className="text-xs text-muted-foreground">
              In Stock
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecommendationHeader;